import type { NextPage } from 'next'
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
	HomeBreadcrumbItem,
} from '~/components/localized-breadcrumb'
import {
	ToggleGroup,
	ToggleGroupItem,
} from '@cocoonspace/ui/components/toggle-group'
import { useLingui } from '@lingui/react/macro'
import { CalendarIcon, LayoutGridIcon } from 'lucide-react'
import { parseAsStringLiteral, useQueryState } from 'nuqs'

import { MainContainer } from '~/components/atoms/main-container'
import { SectionHeader } from '~/components/atoms/section-header'
import { EventsList } from '~/domains/events/components/my-events/events-list'
import { MyEventsCalendar } from '../my-events-calendar'

const PageBreadcrumb = () => {
	const { t } = useLingui()

	return (
		<Breadcrumb>
			<BreadcrumbList>
				<HomeBreadcrumbItem />
				<BreadcrumbSeparator />

				<BreadcrumbItem>
					<BreadcrumbPage>{t`Mes évènements`}</BreadcrumbPage>
				</BreadcrumbItem>
			</BreadcrumbList>
		</Breadcrumb>
	)
}

export const MyEventsPage: NextPage = () => {
	const { t } = useLingui()

	const [view, setView] = useQueryState(
		'view',
		parseAsStringLiteral(['grid', 'calendar']).withDefault('grid'),
	)

	return (
		<MainContainer>
			<PageBreadcrumb />

			<div className='flex flex-col items-center gap-4 md:flex-row'>
				<SectionHeader
					title={t`Mes évènements`}
					subtitle={t`Retrouvez et gérez l'ensemble de vos évènements.`}
				/>

				<ToggleGroup
					type='single'
					value={view}
					className='ml-auto shadow-xs'
					onValueChange={(value) => {
						if (!value) return
						setView(value as 'grid' | 'calendar')
					}}
				>
					<ToggleGroupItem
						value='grid'
						data-umami-event='event-view-clicked'
						data-umami-event-view='grid'
					>
						<LayoutGridIcon />
						{t`Grille`}
					</ToggleGroupItem>

					<ToggleGroupItem
						value='calendar'
						data-umami-event='event-view-clicked'
						data-umami-event-view='calendar'
					>
						<CalendarIcon />
						{t`Calendrier`}
					</ToggleGroupItem>
				</ToggleGroup>
			</div>

			{view === 'grid' && <EventsList />}
			{view === 'calendar' && <MyEventsCalendar />}
		</MainContainer>
	)
}
